import nodeApi from '../utils/nodeApiClient';

// Public settings the login page reads before anyone is signed in.
const settingsApi = {
  getForgotPassword: () => nodeApi.get('/settings/forgot-password')
};

export default settingsApi;
